import bizNodeModel from '../../bizNodeModel.mjs'

export default bizNodeModel({
    algKey: {
        name: () => '方法关键字',
    },

    algTitle: {
        name: (map, node) => {
            const {algType} = node.data
            return 'CONCEPT' === algType ? '变量名称' : '方法标题'
        }
    },

    algUserCode: {
        name: () => '方法代码',
    },
})
